module.exports = __webpack_public_path__ + "img/bench-mark.1db7dad9.png";